<div class="cov-sold-to-information-menu d-flex flex-column gap-2 p-1">
  <h3 class="pb-2">{{ 'soldToInformationMenu.title' | transloco: {count: count()} }}</h3>
  <div
    [class.scroll-area]="MAX_VISIBLE_ADDRESSES_WITHOUT_SCROLLING"
    class="d-flex flex-column gap-3 pr-1"
  >
    <ul>
      @for (address of (addresses$ | async); track address.id) {
        <li class="py-2 d-grid" [innerHTML]="address.displayValue"></li>
      }
    </ul>
  </div>
</div>
